import { useSelector } from 'react-redux';
import { useWebsiteExperimentACQ111 } from '../experiments/acq111/acq111Tracking';
import { useLoadFlow } from '../hooks/useLoadFlow';
import { useRestoreScroll } from '../hooks/useRestoreScroll';
import { useSetupUnloadAlert } from '../hooks/useSetupUnloadAlert';
import { useStartApp } from '../hooks/useStartApp';
import { useTrackStepView } from '../hooks/useTrackStepView';
import { useViewComponent } from '../hooks/useViewComponent';
import { getFlowKey } from '../routing/getFlowKey';
import { getCurrentStep } from '../store/flow/selectors';
export const useViewContainer = () => {
  const {
    unloadAlert
  } = useSetupUnloadAlert();
  const ViewComponent = useViewComponent({
    unloadAlert
  });
  const currentStep = useSelector(getCurrentStep);
  useStartApp();
  useLoadFlow();
  useRestoreScroll();
  useTrackStepView();
  useWebsiteExperimentACQ111();
  return {
    ViewComponent,
    viewContainerProps: {
      'data-step': currentStep,
      flow: getFlowKey()
    }
  };
};